import axios from 'axios';
import { resolveCmsAccessToken, setAxiosAuthorizationHeader } from 'shared/api/cms-access-token';
import { showCmsApiErrorToast } from 'shared/lib/util/cms-api-error-toast';
let client = null;
let lastBaseUrl = null;
/** Set by CmsApiBaseProvider. Invoked on each request so refresh works. */
let accessTokenGetter = null;
/** Optional: host merges headers per request (e.g. `Accept-Language`). */
let requestHeadersGetter = null;
export const setCmsHttpAccessTokenGetter = (getter) => {
    accessTokenGetter = getter;
};
export const setCmsHttpRequestHeadersGetter = (getter) => {
    requestHeadersGetter = getter;
};
const setMergedHeaders = (config, extra) => {
    const h = config.headers;
    for (const [key, value] of Object.entries(extra)) {
        if (value == null || value === '') {
            continue;
        }
        if (h && typeof h.set === 'function') {
            h.set(key, value);
        }
        else {
            h[key] = value;
        }
    }
};
const attachAuthInterceptor = (instance) => {
    instance.interceptors.request.use((config) => {
        const extra = requestHeadersGetter?.();
        if (extra) {
            setMergedHeaders(config, extra);
        }
        const token = resolveCmsAccessToken(accessTokenGetter);
        if (token) {
            setAxiosAuthorizationHeader(config, token);
        }
        return config;
    });
};
const attachApiErrorToast = (instance) => {
    instance.interceptors.response.use(res => res, (err) => {
        if (axios.isCancel(err)) {
            return Promise.reject(err);
        }
        showCmsApiErrorToast(err);
        return Promise.reject(err);
    });
};
const createClient = (baseURL) => {
    const instance = axios.create({ baseURL, withCredentials: false });
    attachAuthInterceptor(instance);
    attachApiErrorToast(instance);
    return instance;
};
export const setCmsHttpBaseUrl = (baseUrl) => {
    const b = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    if (client && lastBaseUrl === b) {
        return;
    }
    lastBaseUrl = b;
    client = createClient(b);
};
export const cmsHttp = () => {
    if (!client) {
        client = createClient();
    }
    return client;
};
